import ICatalog_Item from "../../models/ICatalog_Item";
import _ from "lodash";
import OwInputWrapper from "../../components/shared/OwInputWrapper/OwInputWrapper";
import React, { useMemo } from "react";
import IOwTableCols from "../../models/IOwTableCols";
import IOrder_ItemUI from "../../models/IOrder_ItemUI";
import IQtyAssigned from "../../models/IQtyAssigned";
import IPacking_List from "../../models/IPacking_List";

export const usePackingListDetailViewColumns = (packingList: IPacking_List, orderItems: IOrder_ItemUI[], qtyAssigned: IQtyAssigned, handlePickedChange: (e: any, row: ICatalog_Item, rowIndex: number, isDetailView?: boolean, parentRowIndex?: number) => void) => {
    const columns: IOwTableCols[] = useMemo(() => {

        const renderQtyShipped = (row: ICatalog_Item, rowIndex: number, isDetailView?: boolean, parentRowIndex?: number) => {
            // console.log("qtyPickedRenderedFn", row, rowIndex, isDetailView, parentRowIndex);
            if (!_.isNil(parentRowIndex)) {
                // @ts-expect-error - parentRowIndex is not type defined for the array.
                const parentOrderItem = orderItems[parentRowIndex];

                let value = 0;

                // if (qtyAssigned[parentOrderItem.guid].sources[row.guid]) {
                //     if (qtyAssigned[parentOrderItem.guid].sources[row.guid].qty_picked) {
                //         if (qtyAssigned[parentOrderItem.guid].sources[row.guid].value === 0) {
                //             value = qtyAssigned[parentOrderItem.guid].sources[row.guid].qty_picked;
                //         } else {
                            value = qtyAssigned[parentOrderItem.guid].sources[row.guid].value;
                        // }
                //     } else {
                //         if (qtyAssigned[parentOrderItem.guid].sources[row.guid].value) {
                //             value = qtyAssigned[parentOrderItem.guid].sources[row.guid].value;
                //         }
                //     }
                // }

                if (packingList.is_locked) {
                    return <div className={"text-center"}>{value}</div>;
                } else {
                    // console.log("renderQtyShipped", value, this.state.qtyAssigned[parentOrderItem.guid].sources);

                    return (
                        <OwInputWrapper
                            key={row.guid}
                            type={"number"}
                            value={value}
                            fn={(e: any) => {
                                handlePickedChange(e, row, rowIndex, isDetailView, parentRowIndex);
                            }}
                            name={"qty_assigned"}
                            className={"text-end"}
                        />
                    );
                }
            }
        };


            return [
                {
                    className: "w-2pt25r",
                    isActionsCol: true,
                    title: "",
                    valueProp: "",
                },
                {
                    className: "text-end w-8r",
                    title: "",
                    valueProp: "",
                },
                {
                    className: "w-15r",
                    title: "sku",
                    valueProp: "sku",
                },
                {
                    className: "w-15r",
                    title: "manufacturer",
                    valueProp: "manufacturer",
                },
                {
                    title: "description",
                    valueProp: "description",
                },
                {
                    className: "w-10r text-center-print",
                    title: "ship_qty",
                    valueProp: "",
                    renderFn: renderQtyShipped,
                    renderFnEmitsRow: true,
                },
            ];
    }, [handlePickedChange, orderItems, packingList, qtyAssigned]);

    return columns;
}
